import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../context/auth-context"
import type { Role } from "@shared/types"

export default function StudentRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-ink-50 dark:bg-ink-950">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-700" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/portal/login" state={{ from: location.pathname }} replace />
  }

  // Admins shouldn't access student portal
  if (user.role === "ADMIN" || user.role === "SUPER_ADMIN") {
    return <Navigate to="/admin" replace />
  }

  return <>{children}</>
}
